export default {
	en: {
		translation: {
			shutterstock: {
				no_auth_title: "Upload assets from your Shutterstock account.",
				toggle_filters_button: "Filters",
				no_auth_action: "Connect to Shutterstock",
				authenticating: "Authenticating...",
				statement: "Shutterstock offers the best quality, royalty free stock images, photos, vectors, illustrations, videos and music for nearly any application.",
				reg_link_text: "Click here to create a Shutterstock account",
				next_btn: "Next",
				media_types: {
					images: "Images",
					videos: "Videos",
				},
				filters: {
					more_label: "More",
					sort_options: {
						label: "Sort by",
						newest: "New",
						relevance: "Relevant",
						popular: "Popular",
						random: "Random",
					},
					people: {
						label: "People",
						only_images_with_people: "Only images with people",
						only_videos_with_people: "Only videos with people",
					},
					gender: {
						label: "Gender",
						male: "Male",
						female: "Female",
						both: "Both",
					},
					size: {
						label: "Size",
						small: "Small",
						medium: "Medium",
						large: "Large",
					},
					clear: "clear",
					orientation: {
						label: "Orientation",
						horizontal: "Horizontal",
						vertical: "Vertical",
					},
					color: "Color",
					colors: {
						red: "red",
						orange: "orange",
						amber: "amber",
						yellow: "yellow",
						lime: "lime",
						green: "green",
						teal: "teal",
						turquoise: "turquoise",
						aqua: "aqua",
						azure: "azure",
						blue: "blue",
						purple: "purple",
						orchid: "orchid",
						magenta: "magenta",
					},
					safe: "Safe",
					all_categories: "All Categories",
					types: {
						all: "All image types",
						illustration: "Illustration",
						photo: "Photo",
						vector: "Vector",
					},
					duration: {
						label: "Duration",
						short: "Short",
						short_tip: "< 4 minutes",
						long: "Long",
						long_tip: "> 20 minutes",
					},
					resolution: {
						label: "Resolution",
						standard_definition: "SD",
						standard_definition_tip: "Standard Definition",
						high_definition: "HD",
						high_definition_tip: "High Definition",
						"4k": "4k",
						"4k_tip": "4k",
					},
				},
				filter_summary: {
					label: "Filters: {{- summary}}",
					gender: "only {{value}}",
					people: "with {{value}} people",
					color: "color: {{value}}",
					category: "in {{- value}}",
					unsafe: "unsafe",
				},
				purchase_page: {
					purchase_btn_label: "Purchase",
					plans: {
						label: "Select Plan",
						years: "years",
						days: "days",
						expired: "expired",
						exceeded: "exceeded",
						manage_plans: "Manage your Shutterstock plans...",
						no_plan: "Your current plan does not include ",
					},
					format_and_size: {
						label: "Select Format & Size",
					},
					aspect_ratio: "Aspect Ratio",
					author: "Author",
					description: "Description",
					button_label: {
						purchase: "Purchase",
						acquire: "Purchase",
						next: "Next",
						upload: "Upload",
						purchasing: "Purchasing...",
						downloading: "Downloading...",
					},
					button_description: {
						next: "You already own this {{assetType}} Click Next to continue",
						upload: "You already own this {{assetType}} Click Upload to continue",
						purchasing: "Purchasing - This may take a few seconds...",
						downloading: "Downloading - This may take a few seconds...",
					},
					duration: "Duration",
					fps: "FPS",
					sizes: {
						vector_eps: "Vector",
						small_jpg: "Small",
						medium_jpg: "Medium",
						huge_jpg: "Huge",
						web: "Web",
						sd: "SD",
						hd: "HD",
						"4k": "4K",
					},
					file_limit_exceeded: "Some options have exceeded the upload file-size limit.",
					time_left: "{{time}} left",
				},
				purchase_preview: {
					loading_preview: "Loading preview",
					open_in_new_window: "Open in new window",
				},
				dictionary: {
					image: "image",
					video: "video",
				},
				home_page: {
					results_header: "Popular",
					categories_header: "Categories",
				},
				search: {
					placeholder: "Search...",
					reset: "Reset search",
				},
			},
		},
	},
};
